var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9485 10.3753C21.2938 9.98958 21.2611 9.3969 20.8753 9.05153C20.4896 8.70617 19.8969 8.73891 19.5515 9.12466L15.3401 13.8286C14.4867 14.7818 13.912 15.4203 13.4206 15.8333C12.9526 16.2267 12.6777 16.3125 12.4375 16.3125C12.1973 16.3125 11.9224 16.2267 11.4543 15.8333C10.963 15.4203 10.3883 14.7818 9.53493 13.8286L8.44847 12.6151C8.1031 12.2294 7.51041 12.1966 7.12466 12.542C6.73891 12.8874 6.70617 13.48 7.05153 13.8658L8.18439 15.1311C8.97921 16.019 9.64217 16.7595 10.2479 17.2687C10.8887 17.8073 11.5799 18.1875 12.4375 18.1875C13.2951 18.1875 13.9863 17.8073 14.6271 17.2687C15.2328 16.7595 15.8958 16.019 16.6905 15.1312L20.9485 10.3753Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.0625C6.57867 0.0625 0.5625 6.07867 0.5625 13.5C0.5625 20.9213 6.57867 26.9375 14 26.9375C21.4213 26.9375 27.4375 20.9213 27.4375 13.5C27.4375 6.07867 21.4213 0.0625 14 0.0625ZM2.4375 13.5C2.4375 7.11421 7.61421 1.9375 14 1.9375C20.3858 1.9375 25.5625 7.11421 25.5625 13.5C25.5625 19.8858 20.3858 25.0625 14 25.0625C7.61421 25.0625 2.4375 19.8858 2.4375 13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlined);
export default __webpack_public_path__ + "static/media/CheckOutlined.1858594a10662c0a894259d28d14cbf0.svg";
export { ForwardRef as ReactComponent };